// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Xa91","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1N-0y"};